import { render } from "./_hot-material.vue?vue&type=template&id=184d8cc3&scoped=true"
import script from "./_hot-material.vue?vue&type=script&lang=js"
export * from "./_hot-material.vue?vue&type=script&lang=js"

import "./_hot-material.vue?vue&type=style&index=0&id=184d8cc3&lang=less&scoped=true"
import "./_hot-material.vue?vue&type=style&index=1&id=184d8cc3&lang=less"

import exportComponent from "D:\\微客\\we_customer_guide\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-184d8cc3"]])

export default __exports__